import { Box, Divider, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import companyData from '../../../assets/data/company.json';

const BusinessHours = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: 4,
                    p: {xs: 3, md: 5},
                    flex: 1
                }}
            >
                <Stack
                    direction='column'
                    alignItems='start'
                    justifyContent='space-between'
                    spacing={{xs: 2, md: 3}}
                    height='100%'
                >
                    <Stack
                        direction='column'
                        alignItems='start'
                        justifyContent='start'
                        width='100%'
                        spacing={{xs: 2, md: 3}}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 16, lg: 24}}
                            textAlign="left"
                            lineHeight={1.5}
                            color={theme.palette.text.primary}
                        >
                            {t('contact.businessHours.title')}
                        </Typography>

                        <Divider style={{width: '100%'}}/>
                    </Stack>

                    <Grid
                        direction='row'
                        justifyContent='start'
                        alignItems='start'
                        container
                        width='100%'
                    >
                        <Grid size={6}>
                            <BusinessHourDetails 
                                title={t('contact.businessHours.weekdays')}
                                description={`${companyData.contact.available.weekdays[0]} ${t('contact.businessHours.am')} - ${companyData.contact.available.weekdays[1]} ${t('contact.businessHours.pm')} (GMT +5:30)`}
                            />
                        </Grid>

                        <Grid size={6}>
                            <BusinessHourDetails 
                                title={t('contact.businessHours.weekends')}
                                description={t('contact.businessHours.weekendAvailability')}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default BusinessHours;

const BusinessHourDetails = ({
    title,
    description
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                spacing={1}
            >
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 14, lg: 16}}
                    textAlign="left"
                    lineHeight={1.5}
                    color={theme.palette.text.primary}
                >
                    {title}
                </Typography>

                <Typography
                    fontWeight={500}
                    fontSize={{xs: 12, md: 14, lg: 14}}
                    textAlign="left"
                    lineHeight={1.5}
                    color={theme.palette.text.secondary}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}